/**
 * Directive to format tax ID (DNI) for Chile and Colombia.
 * It listens to the input event and formats the value according to the country's tax ID format.
 * The formatted value is emitted back to the component using the 'input' event.
 * The directive is unbound when the component is destroyed to prevent memory leaks.
 * Supported countries:
 * - CL: Chilean RUT (Rol Único Tributario)
 * - CO: Colombian NIT (Número de Identificación Tributaria)
 * Usage:
 * <input v-dni="'CL'" v-model="chileanTaxId" />
 * <input v-dni="'CO'" v-model="colombianTaxId" />
 * Note: The directive assumes that the input is a text field and does not handle other types of inputs.
 */

import { formatTaxId } from '@/locale/tax-id'

export default {
  unbind (el) {
    if (el.__dniListener) {
      el.removeEventListener('input', el.__dniListener)
    }
  },
  update (el, binding, vnode) {
    const country = binding.value
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')

    if (!vnode.componentInstance || !input) {
      return
    }

    if (el.__dniListener) {
      el.removeEventListener('input', el.__dniListener)
    }

    if (country === 'CL' || country === 'CO') {
      input.value = formatTaxId(country, input.value)
    }

    el.__dniListener = (e) => {
      const inputValue = e.target.value

      if (country === 'CL' || country === 'CO') {
        const formattedTaxId = formatTaxId(country, inputValue)

        if (formattedTaxId !== e.target.value) {
          e.target.value = formattedTaxId
        }

        vnode.componentInstance.$emit('input', formattedTaxId)
        return
      }

      vnode.componentInstance.$emit('input', inputValue)
    }

    el.addEventListener('input', el.__dniListener)
  }
}
